import { FC, useCallback, useState } from "react";
import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/redux";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";
import { tDispatchAction } from "src/redux/types";
import { tBrandEthosMap } from "tmt_api/src/types/types";
import { tValidType, ValidatedTitle } from "./FormInputs";
import { CheckMark2 } from "./NewCheckBox2";

type tMultiCheck = {
  buttonText: string;
  stateInclude: keyof tBrandEthosMap;
  dispatchAction: tDispatchAction;
};

const MultiCheckMark: FC<tMultiCheck> = ({ buttonText, stateInclude, dispatchAction }) => {
  const dispatch = useAppDispatch();
  // const rIsBigDevice = useSelector((state) => state.NavigationReducer.drawerType === "permanent");
  const rBrandEthos = useSelector(({ AdminSettingReducer }) =>
    AdminSettingReducer.type === "brand" ? AdminSettingReducer.brandEthos : [],
  );
  const _dispatchHandler = useCallback(() => dispatch(dispatchAction), [dispatch, dispatchAction]);
  return (
    <CheckMark2
      myLeaveSpace={false}
      textStyle={styles.repApplicationTextStyle}
      style={styles.gApplyMultiCheckBoxInnerContainer}
      myText={buttonText}
      myState={rBrandEthos.includes(stateInclude)}
      textPlacement="right"
      onPress={_dispatchHandler}
    />
  );
};

const BrandEthosOptions: FC = () => {
  const [sIsValid, setIsValid] = useState<tValidType>({});
  const rBrandEthos = useSelector(({ AdminSettingReducer }) =>
    AdminSettingReducer.type === "brand" ? AdminSettingReducer.brandEthos : [],
  );

  //TODO: use the gFormatting kBrandEthosConversion to convert the state to the text @Dayton-Lindsay
  return (
    <View style={styles.gMultiCheckBoxContainer}>
      <ValidatedTitle
        controller={sIsValid}
        setController={setIsValid}
        rules={{ required: { message: "Required" } }}
        isShown={true}
        value={rBrandEthos.length === 0 ? "" : "right"}
        uniqueName="brandEthos"
        myTitle="Brand Ethos"
        textProps={{ style: styles.P08_01_InputHeader }}
      />
      <View style={styles.gApplyMultiCheckBox}>
        <MultiCheckMark
          buttonText="Award Winning"
          stateInclude="awardWinning"
          dispatchAction={{
            type: "ADMIN_UPDATE_BRAND_ETHOS",
            toggle: "awardWinning",
          }}
        />
        <MultiCheckMark
          buttonText="Made In America"
          stateInclude="madeInAmerica"
          dispatchAction={{
            type: "ADMIN_UPDATE_BRAND_ETHOS",
            toggle: "madeInAmerica",
          }}
        />

        <MultiCheckMark
          buttonText="Eco Friendly"
          stateInclude="ecoFriendly"
          dispatchAction={{
            type: "ADMIN_UPDATE_BRAND_ETHOS",
            toggle: "ecoFriendly",
          }}
        />
        <MultiCheckMark
          buttonText="Small Batch"
          stateInclude="smallBatch"
          dispatchAction={{
            type: "ADMIN_UPDATE_BRAND_ETHOS",
            toggle: "smallBatch",
          }}
        />

        <MultiCheckMark
          buttonText="Organic"
          stateInclude="organic"
          dispatchAction={{
            type: "ADMIN_UPDATE_BRAND_ETHOS",
            toggle: "organic",
          }}
        />
        <MultiCheckMark
          buttonText="Not On Amazon"
          stateInclude="notOnAmazon"
          dispatchAction={{
            type: "ADMIN_UPDATE_BRAND_ETHOS",
            toggle: "notOnAmazon",
          }}
        />

        <MultiCheckMark
          buttonText="Woman Owned"
          stateInclude="womanOwned"
          dispatchAction={{
            type: "ADMIN_UPDATE_BRAND_ETHOS",
            toggle: "womanOwned",
          }}
        />
        <MultiCheckMark
          buttonText="Sustainable"
          stateInclude="sustainable"
          dispatchAction={{
            type: "ADMIN_UPDATE_BRAND_ETHOS",
            toggle: "sustainable",
          }}
        />

        <MultiCheckMark
          buttonText="Minority Owned"
          stateInclude="minorityOwned"
          dispatchAction={{
            type: "ADMIN_UPDATE_BRAND_ETHOS",
            toggle: "minorityOwned",
          }}
        />
      </View>
    </View>
  );
};

export default BrandEthosOptions;

const styles = StyleSheet.create({
  P08_01_InputHeader: {
    ...kFonts.formLegend,
  },
  gApplyMultiCheckBox: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
  },
  gApplyMultiCheckBoxInnerContainer: {
    flexDirection: "row",
    marginTop: 6 * kStyleConst.kSpacing,
    width: kStyleConst.kApplyMinWidth,
  },

  gMultiCheckBoxContainer: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  repApplicationTextStyle: {
    marginLeft: 2 * kStyleConst.kSpacing,
  },
});
